export default "__VITE_ASSET__916931fa__"